import { collection, deleteDoc, doc, getDocs, setDoc, Timestamp, updateDoc, } from "firebase/firestore";
import { warnUnknownFields } from "./converterWarnings";
import { prepareForFirestore } from "./utils";
const SERVICE_TAG_FIELDS = [
    "id",
    "path",
    "serviceId",
    "label",
    "description",
    "color",
    "deletedAt",
    "createdAt",
    "updatedAt",
];
const serviceTagConverter = {
    toFirestore(value) {
        return prepareForFirestore(value);
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        warnUnknownFields("packages/ui ServiceTag.fromFirestore", data, SERVICE_TAG_FIELDS);
        return {
            id: snapshot.id,
            path: snapshot.ref.path,
            serviceId: String(data.serviceId || snapshot.ref.parent.parent?.id || ""),
            label: String(data.label || ""),
            description: String(data.description || ""),
            color: data.color || "blue",
            deletedAt: data.deletedAt instanceof Timestamp
                ? data.deletedAt.toDate()
                : data.deletedAt || null,
            createdAt: data.createdAt instanceof Timestamp
                ? data.createdAt.toDate()
                : data.createdAt || new Date().toISOString(),
            updatedAt: data.updatedAt instanceof Timestamp
                ? data.updatedAt.toDate()
                : data.updatedAt || new Date().toISOString(),
        };
    },
};
export function serviceTagsCollection(db, companyId, serviceId) {
    return collection(db, "companies", companyId, "services", serviceId, "tags").withConverter(serviceTagConverter);
}
export function serviceTagDocument(db, companyId, serviceId, tagId) {
    return doc(db, "companies", companyId, "services", serviceId, "tags", tagId).withConverter(serviceTagConverter);
}
export async function fetchServiceTags(db, companyId, serviceId) {
    const snapshot = await getDocs(serviceTagsCollection(db, companyId, serviceId));
    return snapshot.docs.map((tag) => tag.data());
}
export async function createServiceTag(db, companyId, serviceId, data) {
    const docRef = data.id
        ? serviceTagDocument(db, companyId, serviceId, data.id)
        : doc(serviceTagsCollection(db, companyId, serviceId));
    await setDoc(docRef, {
        ...data,
        id: docRef.id,
        serviceId,
        createdAt: new Date(),
        updatedAt: new Date(),
    });
    return docRef.id;
}
export async function updateServiceTag(db, companyId, serviceId, tagId, data) {
    await updateDoc(serviceTagDocument(db, companyId, serviceId, tagId), {
        ...data,
        updatedAt: new Date(),
    });
}
export async function deleteServiceTag(db, companyId, serviceId, tagId) {
    await deleteDoc(serviceTagDocument(db, companyId, serviceId, tagId));
}
